import { Control, FieldError } from "react-hook-form";
import { useRef } from "react";

export function useFieldControl<T>(control: Control<any>, name: string) {
	const values = control.getValues();
	const value = values ? (values[name] as T) : undefined;
	const errors = control.errorsRef.current;
	const error = errors ? (errors[name] as FieldError) : undefined;
	const registerRef = useRef((name: string) => control.register({ name }));
	const unregisterRef = useRef((name: string) => control.unregister(name));
	const setValueRef = useRef((value: T) => {
		control.setValue(name, value);
		control.reRender();
	});

	return {
		value,
		error,
		setValue: setValueRef.current,
		register: registerRef.current,
		unregister: unregisterRef.current,
	};
}
